import { EmptyLayout, MainLayout } from "components/Layout";
import PageSpinner from "components/PageSpinner";
import AuthPage from "pages/AuthPage";
import React from "react";
import componentQueries from "react-component-queries";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import PrivateRoute from './components/PrivateRoute';
import "styles/reduction.scss";
import 'utils/utilityFunctions'

/* Home Page */
const Homepage = React.lazy(() => import("pages/Homepage"))

/* User Pages */
const Users = React.lazy(() => import("pages/admin/user-manage/Users"));
const Personels = React.lazy(() => import("pages/admin/user-manage/Personels"));

/* Product Pages */
const Products = React.lazy(() => import("pages/brand-catalog/product-manage/Products"));
const ProductAdd = React.lazy(() => import("pages/brand-catalog/product-manage/ProductAdd"));
const ProductEdit = React.lazy(() => import("pages/brand-catalog/product-manage/ProductEdit"));
const ProductAudit = React.lazy(() => import("pages/brand-catalog/product-manage/ProductAudit"));

/* Brand Pages */
const BrandManagement = React.lazy(() => import("pages/brand-catalog/brand-dealer/brand-manage/BrandManagement"));
const BrandAdd = React.lazy(() => import("pages/brand-catalog/brand-dealer/brand-manage/BrandAdd"));
const BrandEdit = React.lazy(() => import("pages/brand-catalog/brand-dealer/brand-manage/BrandEdit"));

/* Dealer Pages */
const DealerManagement = React.lazy(() => import("pages/brand-catalog/brand-dealer/dealer-manage/DealerManagement"));
const DealerEdit = React.lazy(() => import("pages/brand-catalog/brand-dealer/dealer-manage/DealerEdit"));
const DealerAdd = React.lazy(() => import("pages/brand-catalog/brand-dealer/dealer-manage/DealerAdd"));

/* Category Pages */
const CategoryManagementPage = React.lazy(() => import("pages/brand-catalog/product-category-manage/CategoryManagement"));
const CategoryGalleriesPage = React.lazy(() => import("pages/brand-catalog/product-category-manage/CategoryGalleries"));

/* Blog - Slider Pages */
const BlogManagement = React.lazy(() => import("pages/admin/blog-manage/BlogManagement"));
const BlogSliderManagement = React.lazy(() => import("pages/admin/blog-manage/BlogSliderManagement"));

/* Magazine Pages */
const MagazineList = React.lazy(() => import("pages/admin/magazine-manage/MagazineList"));
const MagazineAdd = React.lazy(() => import("pages/admin/magazine-manage/MagazineAdd"));
const MagazineEdit = React.lazy(() => import("pages/admin/magazine-manage/MagazineEdit"));

/* Inquiry Pages */
const ProductInquiries = React.lazy(() => import("pages/admin/inquiry-manage/ProductInquiries"));
const SupportRequests = React.lazy(() => import("pages/admin/inquiry-manage/SupportRequests"));
const BrandApplications = React.lazy(() => import("pages/admin/inquiry-manage/BrandApplications"));

/* Feedback Pages */
// const FeedbackManagement = React.lazy(() => import("pages/FeedbackManagement"));

/* Website Pages */
const Professionals = React.lazy(() => import("pages/admin/user-manage/professionals/ProfessionalsPage"));
// const ProfessionalDetail = React.lazy(() => import("pages/admin/user-manage/professionals/ProfessionalDetailPage"));
// const ProfessionalEdit = React.lazy(() => import("pages/admin/user-manage/professionals/ProfessionalEditPage"));
// const ProjectDetail = React.lazy(() => import("pages/admin/user-manage/professionals/ProjectDetailPage"));
// const IdeaPanoDetailPage = React.lazy(() => import("components/Professional/IdeaPanoDetails"));
// const ServiceManagement = React.lazy(() => import("pages/prof-services/service-category-manage/ServiceManagement"));

/* YENI EKLENENLER */
const Ads = React.lazy(() => import("pages/admin/Ads"))
const SssFooter = React.lazy(() => import("pages/admin/SssFooter"))
const Shortcut = React.lazy(() => import("pages/explore/Shortcut"))
const HomepageEdits = React.lazy(() => import("pages/homepage/HomepageEdits"))
const FeaturedServices = React.lazy(() => import("pages/prof-services/FeaturedServices"))
const ServiceFastSearch = React.lazy(() => import("pages/prof-services/service-category-manage/ServiceFastSearch"))
const ProductFastSearch = React.lazy(() => import("pages/brand-catalog/product-category-manage/ProductFastSearch"))
const ServiceCategoryManage = React.lazy(() => import("pages/prof-services/service-category-manage/ServiceCategoryManage"))

class App extends React.Component {

  render() {
    const isLoggedIn = () => {
      return Boolean(
        localStorage.getItem("access_token") || localStorage.getItem("refresh_token")
      );
    };

    return (
      <BrowserRouter>
        <Switch>
          <Route
            exact
            path="/login"
            render={() => (isLoggedIn() ? <Redirect to="/" /> : <AuthPage />)}
          />

          <MainLayout breakpoint={this.props.breakpoint}>
            <React.Suspense fallback={<PageSpinner />}>
              <PrivateRoute exact path="/" component={Homepage} onEnter={isLoggedIn} />

              <PrivateRoute exact path="/users" component={Users} onEnter={isLoggedIn} />
              <PrivateRoute exact path="/personels" component={Personels} onEnter={isLoggedIn} />

              <PrivateRoute exact path="/products" component={Products} onEnter={isLoggedIn} />
              <PrivateRoute exact path="/product-add" component={ProductAdd} onEnter={isLoggedIn} />
              <PrivateRoute exact path="/productEdit" component={ProductEdit} onEnter={isLoggedIn} />
              <PrivateRoute exact path="/productAudit" component={ProductAudit} onEnter={isLoggedIn} />

              <PrivateRoute exact path="/brandManagement" component={BrandManagement} onEnter={isLoggedIn} />
              <PrivateRoute exact path="/brandAdd" component={BrandAdd} onEnter={isLoggedIn} />
              <PrivateRoute exact path="/brandEdit" component={BrandEdit} onEnter={isLoggedIn} />

              <PrivateRoute exact path="/dealerManagement" component={DealerManagement} onEnter={isLoggedIn} />
              <PrivateRoute exact path="/dealerAdd" component={DealerAdd} onEnter={isLoggedIn} />
              <PrivateRoute exact path="/dealerEdit" component={DealerEdit} onEnter={isLoggedIn} />

              <PrivateRoute exact path="/categoryManagement" component={CategoryManagementPage} onEnter={isLoggedIn} />
              <PrivateRoute exact path="/categoryGalleries" component={CategoryGalleriesPage} onEnter={isLoggedIn} />

              <PrivateRoute exact path="/blogManagement" component={BlogManagement} onEnter={isLoggedIn} />
              <PrivateRoute exact path="/blogSliderManagement" component={BlogSliderManagement} onEnter={isLoggedIn} />

              <PrivateRoute exact path="/magazine" component={MagazineList} onEnter={isLoggedIn} />
              <PrivateRoute exact path="/magazine/add" component={MagazineAdd} onEnter={isLoggedIn} />
              <PrivateRoute exact path="/magazine/edit" component={MagazineEdit} onEnter={isLoggedIn} />

              <PrivateRoute exact path="/admin/inquiries/products" component={ProductInquiries} onEnter={isLoggedIn} />
              <PrivateRoute exact path="/admin/inquiries/support" component={SupportRequests} onEnter={isLoggedIn} />
              <PrivateRoute exact path="/admin/inquiries/brand-applications" component={BrandApplications} onEnter={isLoggedIn} />

              <PrivateRoute exact path="/professionals" component={Professionals} onEnter={isLoggedIn} />

              <PrivateRoute exact path="/homepage/homepage-edits" component={HomepageEdits} onEnter={isLoggedIn} />
              <PrivateRoute exact path="/admin/ads" component={Ads} onEnter={isLoggedIn} />
              <PrivateRoute exact path="/admin/sss-footer" component={SssFooter} onEnter={isLoggedIn} />
              <PrivateRoute exact path="/explore/shortcut" component={Shortcut} onEnter={isLoggedIn} />
              <PrivateRoute exact path="/prof-services/featured" component={FeaturedServices} onEnter={isLoggedIn} />
              <PrivateRoute exact path="/prof-services/service-category-management" component={ServiceCategoryManage} onEnter={isLoggedIn}/>
              <PrivateRoute exact path="/prof-services/fast-search" component={ServiceFastSearch} onEnter={isLoggedIn} />
              <PrivateRoute exact path="/brand-catalog/fast-search" component={ProductFastSearch} onEnter={isLoggedIn} />
            </React.Suspense>
          </MainLayout>
          
          <Redirect to="/" />
        </Switch>
      </BrowserRouter>
    );
  }
}

const query = ({ width }) => {
  if (width < 575) return { breakpoint: "xs" };
  if (576 < width && width < 1000) return { breakpoint: "sm" };
  if (1000 < width && width < 1500) return { breakpoint: "md" };
  if (1500 < width && width < 2000) return { breakpoint: "lg" };
  if (width > 1200) return { breakpoint: "xl" };
  return { breakpoint: "xs" };
};

export default componentQueries(query)(App);